import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { NotificationContainer } from 'react-notifications';
import EditarCadastrarRegiao from './EditarCadastrar';
import InserirBairros from './InserirBairro';
import { Container, InputGroup, Stack, Table } from 'rsuite';
import { useAuth } from '../../hooks/auth';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { CustomCell } from '../../components/CustomCell';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';
import { CustomInput } from '../../components/CustomInput';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomButton } from '../../components/CustomButton';
import api from '../../services/api';
import { debounce, moeda } from '../../components/funcoes';
import PlusIcon from '@rsuite/icons/Plus';
import SearchIcon from '@rsuite/icons/Search';
import { FaMap } from 'react-icons/fa';

const { Column } = Table;

export default function Regioes() {
  const { id_empresa } = useAuth();
  const [loading, setLoading] = useState(true);
  const [regioes, setRegioes] = useState([]);
  const [regiao, setRegiao] = useState(null);
  const [open, setOpen] = useState(false);
  const [openBairros, setOpenBairros] = useState(false);
  const { theme } = useCustomTheme();

  const [busca, setBusca] = useState('');
  const regioesMemo = useMemo(
    () =>
      busca.trim() === ''
        ? regioes
        : regioes.filter(({ Descricao = '' }) =>
            Descricao?.toLocaleLowerCase().includes(busca),
          ),
    [busca, regioes],
  );

  const atualizar = useCallback(async () => {
    await api
      .get(`regiao/listarGestor/${id_empresa}`)
      .then((res) => {
        setRegioes(res.data);
      })
      .catch((error) => console.log(error));
    setLoading(false);
  }, [id_empresa]);

  const debounceSearch = debounce((valor = '') => {
    setBusca(valor.toLocaleLowerCase());
  }, 1000);

  useEffect(() => {
    atualizar();
  }, [atualizar]);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Regiões"
        subtitle="Gerencie as regiões da sua empresa"
        icon={FaMap}
        style={{ zIndex: 0 }}
        secondComponent={
          <InputGroup inside style={{ width: '36vw', border: 'none' }}>
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <Stack spacing={10}>
            <DuvidasButton tela="regiao" />
            <CustomButton
              appearance="primary"
              onClick={() => {
                setRegiao(null);
                setOpen(true);
              }}
            >
              <PlusIcon style={{ marginRight: 6 }} /> Cadastrar Região
            </CustomButton>
          </Stack>
        }
      />
      <Table
        height={window.innerHeight - 60 - 90}
        autoHeight
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        bordered={true}
        loading={loading}
        data={regioesMemo}
        width={'100%'}
        locale={{
          emptyMessage: 'Nenhuma região encontrada',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          align="center"
          fixed
        >
          <CustomHeaderCell>Código</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Região</CustomHeaderCell>
          <CustomCell dataKey="Descricao" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Frete Grátis a partir:</CustomHeaderCell>

          <CustomCell>
            {(rowData) => <text>{moeda(rowData.TaxaGratis)}</text>}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={100}
          fixed="right"
        >
          <CustomHeaderCell>Ativo</CustomHeaderCell>
          <CustomCell dataKey="Fim">
            {(rowData) => (
              <span style={{ padding: 0 }}>
                {!!rowData.Ativo ? (
                  <CustomButton
                    appearance="ghost"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      width: 50,
                    }}
                  >
                    {' '}
                    Sim{' '}
                  </CustomButton>
                ) : (
                  <CustomButton
                    appearance="primary"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      width: 50,
                    }}
                  >
                    {' '}
                    Não{' '}
                  </CustomButton>
                )}
              </span>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={150}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <>
                <span>
                  <CustomButton
                    color={theme.colors.warning}
                    appearance="ghost"
                    size="xs"
                    onClick={() => {
                      setRegiao(rowData);
                      setOpen(true);
                    }}
                  >
                    {' '}
                    Editar{' '}
                  </CustomButton>
                  {' | '}
                  <CustomButton
                    color="violet"
                    appearance="ghost"
                    size="xs"
                    onClick={() => {
                      setRegiao(rowData);
                      setOpenBairros(true);
                    }}
                  >
                    {' '}
                    Bairros{' '}
                  </CustomButton>
                </span>
              </>
            )}
          </CustomCell>
        </Column>
      </Table>
      {open && (
        <EditarCadastrarRegiao
          modal={open}
          close={() => setOpen(false)}
          regiao={regiao}
          setRegioes={setRegioes}
          id_empresa={id_empresa}
        />
      )}

      {openBairros && (
        <InserirBairros
          modal={openBairros}
          close={() => setOpenBairros(false)}
          regiao={regiao}
          id_empresa={id_empresa}
        />
      )}
      <NotificationContainer />
    </Container>
  );
}
